import React from "react";
import "./Footer.css";
import { FaInstagram, FaFacebook, FaPhoneAlt, FaEnvelope } from "react-icons/fa"; // Importando os ícones
import logo from "../../images/logo2.jpg";

const Footer = () => {
  return (
    <section className="contato" id="contato">
      <div className="contato-content">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>

        <div className="contato-text">
          <h3>Nos siga nas redes sociais!</h3>
          <ul>
            <li>
              <a
                href="https://www.instagram.com/advocaciamazzola/"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram className="social-icon" /> Instagram
              </a>
            </li>
            <li>
              <a
               href="https://www.facebook.com/profile.php?id=61570248422290"
               target="_blank"
                rel="noreferrer"
              >
                <FaFacebook  className="social-icon" /> Facebook
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="contato-itens">
        <div className="footer-iten">
          <FaPhoneAlt className="footer-icon" /> <p>(16) 93500-6397</p>
        </div>

        <div className="footer-iten">
          <FaEnvelope className="footer-icon" /> <p>mariliamazzola@gmail.com</p>
        </div>
      </div>

      <div className="footer-bottom">
        <a href="https://wa.me/5591984891906" target="_blank" rel="noreferrer">
          <p>© 2024 João Arthur Lima da Silva • Todos os direitos reservados</p>
        </a>
      </div>
    </section>
  );
};

export default Footer;
